import axios from 'axios';
import { backendUrl } from '../constants/urls';
import { createApiError } from '../../helpers/apiErrorHandler';

/**
 *
 * @param details
 * @returns data got from the API
 */
const login = async (details: any) => {
	try {
		const { data } = await axios.post(`${backendUrl}/admin/auth/login`, details);
		return data;
	} catch (err: any) {
		console.log(err);
		return createApiError(err, 'Server Error: Cannot login user');
	}
};

const verify = async (token: string) => {
	try {
		const config = {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		};
		const { data } = await axios.get(`${backendUrl}/admin/auth/getMe`, config);
		return data;
	} catch (err: any) {
		console.log(err);
		return createApiError(err, 'Server Error: Cannot verify you');
	}
};

const forgotPassword = async (email: string) => {
	try {
		const { data } = await axios.post(`${backendUrl}/admin/auth/reset/forgot-password`, { email });
		return data;
	} catch (err: any) {
		console.log(err);
		return createApiError(err, 'Server Error: Cannot send reset token');
	}
};

const verifyOtp = async (email: string, code: string) => {
	try {
		const { data } = await axios.post(`${backendUrl}/admin/auth/reset/verify-otp`, { email, code });
		return data;
	} catch (err: any) {
		console.log(err);
		return createApiError(err, 'Server Error: Cannot verify OTP');
	}
};

const resetPassword = async (details: {
	email: string;
	newPassword: string;
	confirmPassword: string;
}) => {
	try {
		const { data } = await axios.post(`${backendUrl}/admin/auth/reset-password`, details);
		return data;
	} catch (err: any) {
		console.log(err);
		return createApiError(err, 'Server Error: Cannot reset password');
	}
};

const authAPI = { login, verify, forgotPassword, verifyOtp, resetPassword };

export default authAPI;
